import { createSlice } from '@reduxjs/toolkit'

const setting = createSlice({
    name: 'setting',//Данные для виджетов 
    initialState: {
        user: null,
        companyService: null,
        userParameter: [],
        authExternal: [],//Список внешних авторизаций
        botMaxExist: null,//Наличие бота Макс
        companyStatus: null,//Статус компании (-100:Нет компании; -1:Нет оплаты; 0:Пробный период; 1:Оплачена; 100:Free)
    },
    reducers: {
        loadUser(state, action) {
            state.user = action.payload.data;
        },
        updateUser(state, action) {
            state.user = action.payload.data;
        },
        loadCompanyService(state, action) {
            state.companyService = action.payload.data;
        },
        updateCompanyService(state, action) {
            state.companyService = action.payload.data;
        },
        loadUserParameter(state, action) {
            state.userParameter = action.payload.data;
        },
        updateUserParameter(state, action) {
            state.userParameter = action.payload.data;
        },
        loadAuthExternal(state, action) {
            state.authExternal = action.payload.data;
        },
        updateBotMax(state, action) {
            state.botMaxExist = action.payload.data;
        },
        updateCompanyStatus(state, action) {
            state.companyStatus = action.payload.data;
        },
    }
})

export const { loadUser, updateUser, loadCompanyService, updateCompanyService, loadUserParameter, updateUserParameter, loadAuthExternal, updateBotMax, updateCompanyStatus } = setting.actions
export default setting.reducer